<template>
  <label class="switch">
    <input type="checkbox" :disabled="disabled" :checked="keyValue" @change="changecheckbox($event.target.checked)">
    <span class="slider"></span>
  </label>
</template>

<script>

export default {
  name: 'Checkbox',
  props: ['checkboxModel', 'disabled'],
  computed: {
    keyName (){
      return Object.keys(this.checkboxModel)[0];
    },
    keyValue (){
      return Object.values(this.checkboxModel)[0];
    }
  },
  methods: {
    changecheckbox(value){
      this.$emit('changecheckbox', this.keyName, value);
    }
  },
}

</script>

<style lang="scss">

</style>
